import { RootState } from "index";

export const selectCountriesState = (state: RootState) => state.countries